import Notification from "./NotificationMessage";

export default Notification;